import { DatePicker, message, Pagination, TableColumnsType, Tabs, Typography } from "antd";
import { ContentWrapper, DataTable } from "~/Components";
// import "../../../index.css";
import { Action, TableDrawer } from "@components/TableDrawer/TableDrawer";
import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { drilldownData, ModuleConfig } from "@utils/drilldownData";
import { get as _get, debounce } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { eramanBEApi } from "~/Services";
import { getCurrentModule, getModulePath } from "~/Utils/StringConstants";
import { renderDateColumn } from "~/Utils/TableRenderFunction";
import { useProductReviewsDocumentDetails } from "./ProductReviews.hook";
const { RangePicker } = DatePicker;

export const ProductReviews = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const activeTab = query.get("activeTab");
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchString, setSearchString] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [data, setData] = useState<any>([]);
  const [sortOrder, setSortOrder] = useState<string>("desc");
  const [orderByName, setOrderByName] = useState<string>("date");
  const [startDateType, setStartDateType] = useState<any>("");
  const [endDateType, setEndDateType] = useState<any>("");
  const [id, setId] = useState<string | undefined>(selectedRowData?.id);
  console.log("approvalManagement", data, sortOrder, orderByName, totalRecords);
  const currentModule = getCurrentModule();

  useEffect(() => {
    setId(selectedRowData?.id);
  }, [selectedRowData]);

  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/${getModulePath(currentModule)}/product-reviews?activeTab=pending`, {
        replace: true,
      });
    }
  }, []);

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchDocument,
  } = useProductReviewsDocumentDetails(id || "");

  useEffect(() => {
    if (id) {
      refetchDocument();
    }
  }, [id]);

  const columns: TableColumnsType = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "EPC ID",
      dataIndex: "epcId",
      key: "epcId",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "epcId"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "epcId"
            ? "descend"
            : undefined,
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "productName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "productName"
            ? "descend"
            : undefined,
    },
    // {
    //   title: "Product Code",
    //   dataIndex: "productCode",
    //   key: "productCode",
    //   sorter: true,
    //   sortOrder:
    //     sortOrder === "asc" && orderByName === "productCode"
    //       ? "ascend"
    //       : sortOrder === "desc" && orderByName === "productCode"
    //         ? "descend"
    //         : undefined,
    // },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "rating"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "rating"
            ? "descend"
            : undefined,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "title"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "title"
            ? "descend"
            : undefined,
    },
    {
      title: "Submitted At",
      dataIndex: "date",
      key: "date",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "date"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "date"
            ? "descend"
            : undefined,
    },
    {
      title: "Viewed At",
      dataIndex: "viewedAt",
      key: "viewedAt",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "viewedAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "viewedAt"
            ? "descend"
            : undefined,
    },
    ...(activeTab === "rejected"
      ? [
          {
            title: "Rejected Reason",
            dataIndex: "rejectReason",
            key: "rejectReason",
          },
        ]
      : []),
    {
      title: "Actions",
      key: "actions",
      render: (record: any) => {
        return (
          <div className="relative inline-block">
            <Icon
              height={25}
              icon={"iconamoon:eye"}
              className="text-blue-600 border border-blue-600 rounded-full p-0.5"
              onClick={(e) => {
                e.preventDefault();
                setSelectedRowData?.(record);
                setDrawerVisible?.(true);
              }}
            />
            {!record.viewedAt && <span className="absolute top-0 right-0 block w-2.5 h-2.5 bg-red-500 rounded-full" />}
          </div>
        );
      },
    },
  ];

  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    // getRecords(order, column.dataIndex, searchString, currentPage);
  };

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setSearchString(value);
    setIsLoading(isLoading);
    setCurrentPage(1);
  }, 1000);

  useEffect(() => {
    getRecords(sortOrder, orderByName, searchString, currentPage);
  }, [activeTab, searchString, startDateType, endDateType, sortOrder, currentPage, drawerVisible]);

  const handleApprove = async () => {
    try {
      let url = `/admin/reviews`;
      eramanBEApi
        .put(url, {
          reviewId: selectedRowData.id,
          action: "Approved",
        })
        .then((res) => {
          message.success("Approved successfully!");
          getRecords(sortOrder, orderByName, searchString, currentPage);
          setDrawerVisible(false);
        })
        .catch((err) => {
          message.error("Failed to approve!");
        });
    } catch (error) {
      message.error("Failed to approve!");
    }
  };

  const handleReject = async (reason?: string) => {
    if (!reason) return message.error("Please provide reason for rejection");
    try {
      eramanBEApi
        .put(`/admin/reviews?reviewId`, {
          reviewId: selectedRowData.id,
          action: "Rejected",
          rejectReason: reason,
        })
        .then((res) => {
          message.success("Rejected successfully!");
          getRecords(sortOrder, orderByName, searchString, currentPage);
          setDrawerVisible(false);
        })
        .catch((err) => {
          message.error("Failed to approve!");
        });
    } catch (error) {
      message.error("Failed to approve!");
    }
  };

  const actions: Action[] = [
    { label: "Approve", onClick: handleApprove, type: "primary" },
    {
      label: "Reject",
      onClick: handleReject,
      type: "ghost",
    },
  ];
  const items = [
    {
      label: "Pending",
      key: "pending",
      children: (
        <>
          <DataTable
            tabOffset={60}
            columns={columns.map((col: any) => ({
              ...col,
              onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
            }))}
            className="table-clickable"
            tableData={
              data
                ? data?.map((d: any) => {
                    return {
                      ...d,
                    };
                  })
                : []
            }
            isLoading={isLoading}
            exportFileName="CONTRACT"
            isPagination={true}
            recordsPerPage={10}
            multiSelect={false}
            hideExport={true}
            isServerSearchApi={true}
            searchPlaceholderText={"Search by Product Name"}
            onSearchChange={handleSearchChange}
            additionalCTA={
              <RangePicker
                value={[startDateType ? moment(startDateType) : null, endDateType ? moment(endDateType) : null]}
                onChange={(dates, dateStrings) => {
                  const [start, end] = dateStrings;
                  setStartDateType(start ? moment(start).format("YYYY-MM-DD") : "");
                  setEndDateType(end ? moment(end).format("YYYY-MM-DD") : "");
                }}
                format="YYYY-MM-DD"
                placeholder={["Select Start Date", "Select End Date"]}
                className="mr-2"
                onKeyDown={(e) => e.preventDefault()}
              />
            }
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              current={currentPage}
              total={totalRecords}
              pageSize={10}
              onChange={(page) => {
                setCurrentPage(page);
              }}
              showSizeChanger={false}
              // showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            />
          </div>
        </>
      ),
    },
    {
      label: "Rejected",
      key: "rejected",
      children: (
        <>
          <DataTable
            tabOffset={60}
            columns={columns.map((col: any) => ({
              ...col,
              onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
            }))}
            className="table-clickable"
            tableData={
              data
                ? data?.map((d: any) => {
                    return {
                      ...d,
                    };
                  })
                : []
            }
            isLoading={isLoading}
            exportFileName="CONTRACT"
            isPagination={true}
            recordsPerPage={10}
            isServerSearchApi={true}
            multiSelect={false}
            hideExport={true}
            searchPlaceholderText={"Search by Product Name"}
            onSearchChange={handleSearchChange}
            onClick={(record) => {
              setSelectedRowData(record);
            }}
            additionalCTA={
              <RangePicker
                value={[startDateType ? moment(startDateType) : null, endDateType ? moment(endDateType) : null]}
                onChange={(dates, dateStrings) => {
                  const [start, end] = dateStrings;
                  setStartDateType(start ? moment(start).format("YYYY-MM-DD") : "");
                  setEndDateType(end ? moment(end).format("YYYY-MM-DD") : "");
                }}
                format="YYYY-MM-DD"
                placeholder={["Select Start Date", "Select End Date"]}
                className="mr-2"
                onKeyDown={(e) => e.preventDefault()}
              />
            }
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              current={currentPage}
              total={totalRecords}
              pageSize={10}
              onChange={(page) => {
                setCurrentPage(page);
              }}
              showSizeChanger={false}
              // showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            />
          </div>
        </>
      ),
    },
    {
      label: "Approved",
      key: "approved",
      children: (
        <>
          <DataTable
            tabOffset={60}
            columns={columns.map((col: any) => ({
              ...col,
              onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
            }))}
            className="table-clickable"
            tableData={
              data
                ? data?.map((d: any) => {
                    return {
                      ...d,
                    };
                  })
                : []
            }
            isLoading={isLoading}
            exportFileName="CONTRACT"
            isPagination={true}
            recordsPerPage={10}
            multiSelect={false}
            hideExport={true}
            isServerSearchApi={true}
            searchPlaceholderText={"Search by Product Name"}
            onSearchChange={handleSearchChange}
            additionalCTA={
              <RangePicker
                value={[startDateType ? moment(startDateType) : null, endDateType ? moment(endDateType) : null]}
                onChange={(dates, dateStrings) => {
                  const [start, end] = dateStrings;
                  setStartDateType(start ? moment(start).format("YYYY-MM-DD") : "");
                  setEndDateType(end ? moment(end).format("YYYY-MM-DD") : "");
                }}
                format="YYYY-MM-DD"
                placeholder={["Select Start Date", "Select End Date"]}
                className="mr-2"
                onKeyDown={(e) => e.preventDefault()}
              />
            }
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              current={currentPage}
              total={totalRecords}
              pageSize={10}
              onChange={(page) => {
                setCurrentPage(page);
              }}
              showSizeChanger={false}
              // showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            />
          </div>
        </>
      ),
    },
  ];

  const getRecords = (sortOrder: string, orderByParam: string, searchString: any, currentPage?: number) => {
    let activeTab = query?.get("activeTab");
    if (!activeTab) return;
    let currentModule = getCurrentModule();
    setIsLoading(true);
    let url = `/admin/reviews?pageNo=${currentPage}&pageSize=${10}&sortBy=${orderByParam || ""}&sortOrder=${sortOrder || ""}&search=${searchString || ""}&filter=${activeTab}&startDate=${startDateType || ""}&endDate=${endDateType || ""}`;
    eramanBEApi
      .get(url)
      .then((res: any) => {
        if (res) {
          console.log("records", res.data.totalRows);
          let envelopes = res.data.data;
          setTotalRecords(res.data.totalRows);
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        setIsLoading(false);
      });
  };

  return (
    <ContentWrapper
      title={"Product Reviews"}
      // loading={drilldownLoading}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
          setSearchString("");
          setCurrentPage(1);
        }}
      ></Tabs>
      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className={"!mb-0"}
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        fields={drilldownData[_get(drilldown, "subModule", "productReviews") as ModuleConfig]}
        actions={query?.get("activeTab") == "pending" ? actions : []}
        data={drilldown}
      />
    </ContentWrapper>
  );
};
